import { PrinterPosStopOutlineIcon } from './PrinterPosStopOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E789327B-828B-4E02-976E-1522B0E92151
 * name printer-pos-stop-outline
 * version: 7.1.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/printer-pos-stop-outline.svg
 * tags
 * - Printer 
 */
export const PrinterReceiptStopOutlineIcon = PrinterPosStopOutlineIcon;
export default PrinterReceiptStopOutlineIcon